export function expectNever(value: never): never {
    throw new Error(`Value "${value}" is not expected!`);
}